import Swiper from 'swiper';
import GLightbox from 'glightbox';

export default {
  init() {
  },
  finalize() {

    const lightbox = GLightbox();

    new Swiper('#service-work .swiper-container', {
      slidesPerView: 'auto',
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/work.js